<header>
  <nav class="navbar navbar-expand-lg px-lg-4">
    <div class="container">
      <!-- Logo and Toggler -->
      <div class="d-flex justify-content-md-start justify-content-between align-items-center w-100">
        <a class="navbar-brand logo-hover" routerLink="/">
          <img loading="lazy" src="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/ghrcacs-logo-white.webp"
            alt="GHRCACS, PUNE">
        </a>
        <button class="navbar-toggler" type="button" (click)="toggleNavbar()"
          [ngClass]="{'active': !isNavbarCollapsed}">
          <span class="fa fa-bars"></span>
        </button>

        <app-header-menu></app-header-menu>

      </div>

      <!-- Navbar links -->
      <div class="main-navbar" [ngClass]="{'collapse navbar-collapse': true, 'show': !isNavbarCollapsed}"
        id="navbar-content">
        <ul class="navbar-nav ms-auto">

          <!-- About Dropdown -->
          <li class="nav-item dropdown"
            [ngClass]="{'show': openDropdown === 'about', 'active': isActiveRoute('/about')}">
            <a class="nav-link dropdown-toggle" href="javascript:void(0);" (click)="toggleDropdown('about', $event)"
              [ngClass]="{'active': isActiveRoute('/about')}"> About </a>
            <ul class="dropdown-menu fade-down" [ngClass]="{'show': openDropdown === 'about'}">
              <li> <a class="dropdown-item" routerLink="/about-institute" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/about-institute'}"> About Institute </a> </li>
              <li> <a class="dropdown-item" routerLink="/about-rgi" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/about-rgi'}"> About Raisoni Group </a> </li>
              <li> <a class="dropdown-item" routerLink="/vision-mission" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/vision-mission'}"> Vision and Mission </a> </li>
              <li> <a class="dropdown-item" routerLink="/chairmans-message" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/chairmans-message'}"> Chairman's Message </a> </li>
              <li> <a class="dropdown-item" routerLink="/director-message" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/director-message'}"> Director's Message </a> </li>
              <li> <a class="dropdown-item" routerLink="/principle-message" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/principle-message'}"> Dy. Director's Message </a> </li>
              <li> <a class="dropdown-item" routerLink="/core-value" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/core-value'}"> Core Values </a> </li>
              <li> <a class="dropdown-item" routerLink="/code-of-conduct" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/code-of-conduct'}"> Dy. Director's Message </a> </li>
              <li> <a class="dropdown-item" routerLink="/governing-body" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/governing-body'}"> Governing Body </a> </li>
            </ul>
          </li>
          <!-- Admissions Dropdown -->
          <li class="nav-item dropdown"
            [ngClass]="{'show': openDropdown === 'admission', 'active': isActiveRoute('/admission')}">

            <a class="nav-link dropdown-toggle" href="javascript:void(0);" (click)="toggleDropdown('admission', $event)"
              [ngClass]="{'active': isActiveRoute('/admission')}"> Admission </a>

            <ul class="dropdown-menu fade-down" [ngClass]="{'show': openDropdown === 'admission'}">
              <!-- <li>
                <a class="dropdown-item" routerLink="/admission-overview" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/admission-overview'}">
                  Admission Overview
                </a>
              </li> -->
              <li>
                <a class="dropdown-item" routerLink="/ug-programs" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/ug-programs'}">
                  Under Graduate Programs
                </a>
              </li>
              <li>
              <li>
                <a class="dropdown-item" routerLink="/pg-programs" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/pg-programs'}">
                  Post Graduate Programs
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/eligibility-intake" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/eligibility-intake'}">
                  Eligibility & Intake
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/admission-helpline" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/admission-helpline'}">
                  Admission Helpline
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/faq" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/faq'}">
                  FAQs
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/online-fees-payment" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/-online-fees-payment'}">
                  Online Fees Payment & NEFT Bank Details
                </a>
              </li>
            </ul>
          </li>

          <!-- Academics Dropdown -->
          <li class="nav-item dropdown"
            [ngClass]="{'show': openDropdown === 'academics', 'active': isActiveRoute('/academics')}">
            <a class="nav-link dropdown-toggle" href="javascript:void(0);" (click)="toggleDropdown('academics', $event)"
              (mouseenter)="onMouseEnter('academics')" (mouseleave)="onMouseLeave()"
              [ngClass]="{'active': isActiveRoute('/academics')}">
              Academics
            </a>

            <ul class="dropdown-menu fade-down" [ngClass]="{'show': openDropdown === 'academics'}"
              (mouseenter)="onMouseEnter('academics')" (mouseleave)="onMouseLeave()">

              <li>
                <a class="dropdown-item" routerLink="/exam-circulars" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/exam-circulars'}">
                  Exam Circulars
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/academic-calender" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/academic-calender'}">
                  Academic Calender
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/code-of-ethics" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/code-of-ethics'}">
                  Code of Ethics
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/feedback-process" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/feedback-process'}">
                  Feedback Process
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/student-projects" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/student-projects'}">
                  Student Projects - 2024-25
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/question-paper" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/question-paper'}">
                  Question Papers
                </a>
              </li>
              <li>
                <a class="dropdown-item" routerLink="/po-co" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/po-co'}">
                  POs & COs
                </a>
              </li>
            </ul>
          </li>


          <!-- Committee Mega Menu -->
          <li class="nav-item dropdown dropdown-mega position-static"
            [ngClass]="{'show': openDropdown === 'committee', 'active': isActiveRoute('/committee')}">

            <a class="nav-link dropdown-toggle" href="javascript:void(0);" (click)="toggleDropdown('committee', $event)"
              (mouseenter)="onMouseEnter('committee')" (mouseleave)="onMouseLeave()"
              [ngClass]="{'active': isActiveRoute('/committee')}">
              Committee
            </a>

            <div class="dropdown-menu" [ngClass]="{'show': openDropdown === 'committee'}"
              (mouseenter)="onMouseEnter('committee')" (mouseleave)="onMouseLeave()">

              <div class="mega-content">
                <div class="container-fluid">
                  <div class="row row-cols-1 row-cols-lg-3">

                    <div class="col">
                      <ul>
                        <li><a class="dropdown-item" routerLink="/divyang-committee" (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/divyang-committee'}">Divyang Committee</a></li>
                        <li><a class="dropdown-item" routerLink="/grievance-registration-form" (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/grievance-registration-form'}">Grievance
                            Registration Form</a></li>
                        <li><a class="dropdown-item" routerLink="/anti-ragging-committee" (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/anti-ragging-committee'}">Anti Ragging
                            Committee</a></li>
                        <li><a class="dropdown-item" routerLink="/online-anti-ragging-affidavits"
                            (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/online-anti-ragging-affidavits'}">Online Anti
                            Ragging Affidavits</a></li>
                        <li><a class="dropdown-item" routerLink="/college-development-committee" (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/college-development-committee'}">College
                            Development Committee</a></li>
                        <li><a class="dropdown-item" routerLink="/grievance-redressal-committee" (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/grievance-redressal-committee'}">Grievance
                            Redressal Committee</a></li>
                      </ul>
                    </div>

                    <div class="col">
                      <ul>
                        <li><a class="dropdown-item" routerLink="/sports-cultural-committee" (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/sports-cultural-committee'}">Sports & Cultural
                            Committee</a></li>
                        <li><a class="dropdown-item" routerLink="/student-council-committee" (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/student-council-committee'}">Student Council
                            Committee</a></li>
                        <li><a class="dropdown-item" routerLink="/training-placement-committee" (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/training-placement-committee'}">Training &
                            Placement Committee</a></li>
                        <li><a class="dropdown-item" routerLink="/womens-grievance-redressal-committee"
                            (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/womens-grievance-redressal-committee'}">Womens
                            Grievance Redressal Committee</a></li>
                        <li><a class="dropdown-item" routerLink="/admission-cell-committee" (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/admission-cell-committee'}">Admission Cell
                            Committee</a></li>
                      </ul>
                    </div>

                    <div class="col">
                      <ul>
                        <li><a class="dropdown-item" routerLink="/planning-evaluation-committee" (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/planning-evaluation-committee'}">Planning and
                            Evaluation Committee</a></li>
                        <li><a class="dropdown-item" routerLink="/academic-monitoring-discipline-committee"
                            (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/academic-monitoring-discipline-committee'}">Academic
                            Monitoring and Discipline Committee</a></li>
                        <li><a class="dropdown-item" routerLink="/examination-committee" (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/examination-committee'}">Examination Committee</a>
                        </li>
                        <li><a class="dropdown-item" routerLink="/research-development-committee"
                            (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/research-development-committee'}">Research and
                            Development Committee</a></li>
                        <li><a class="dropdown-item" routerLink="/building-maintenance-purchase-committee"
                            (click)="closeNavbar()"
                            [ngClass]="{'active': currentRoute === '/building-maintenance-purchase-committee'}">Building
                            Maintenance & Purchase Committee</a></li>
                      </ul>
                    </div>

                  </div>
                </div>
              </div>

            </div>
          </li>


          <!-- Placement Dropdown -->
          <li class="nav-item dropdown"
            [ngClass]="{'show': openDropdown === 'placement', 'active': isActiveRoute('/placement-process')}">
            <a class="nav-link dropdown-toggle" href="javascript:void(0);" (click)="toggleDropdown('placement', $event)"
              (mouseenter)="onMouseEnter('placement')" (mouseleave)="onMouseLeave()"
              [ngClass]="{'active': isActiveRoute('/placement-process')}">
              Placement
            </a>

            <ul class="dropdown-menu fade-down" [ngClass]="{'show': openDropdown === 'placement'}"
              (mouseenter)="onMouseEnter('placement')" (mouseleave)="onMouseLeave()">

              <li><a class="dropdown-item" routerLink="/placement-process" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/placement-process'}">Placement Process</a></li>
              <li><a class="dropdown-item" routerLink="/placement-team" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/placement-team'}">Placement Team</a></li>
              <li><a class="dropdown-item" routerLink="/internship" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/internship'}">Internship</a></li>
              <li><a class="dropdown-item" routerLink="/past-recruiters" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/past-recruiters'}">Past Recruiters</a></li>
              <li><a class="dropdown-item" routerLink="/testimonials" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/testimonials'}">Testimonials</a></li>
              <li><a class="dropdown-item" routerLink="/rocs" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/rocs'}">ROCS</a></li>
            </ul>
          </li>
          <!-- Campus Life Dropdown -->
          <li class="nav-item dropdown"
            [ngClass]="{'show': openDropdown === 'campus-life', 'active': isActiveRoute('/hostel')}">
            <a class="nav-link dropdown-toggle" href="javascript:void(0);"
              (click)="toggleDropdown('campus-life', $event)" (mouseenter)="onMouseEnter('campus-life')"
              (mouseleave)="onMouseLeave()" [ngClass]="{'active': isActiveRoute('/hostel')}">
              Campus Life
            </a>
            <ul class="dropdown-menu fade-down" [ngClass]="{'show': openDropdown === 'campus-life'}"
              (mouseenter)="onMouseEnter('campus-life')" (mouseleave)="onMouseLeave()">

              <li><a class="dropdown-item" routerLink="/hostel" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/hostel'}">Hostel</a></li>
              <li><a class="dropdown-item" routerLink="/latest-news" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/latest-news'}">Latest News</a></li>
              <li><a class="dropdown-item" routerLink="/library" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/library'}">Library</a></li>
              <li><a class="dropdown-item" routerLink="/labs" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/labs'}">Labs</a></li>
              <li><a class="dropdown-item" routerLink="/students-achievement" (click)="closeNavbar()"
                  [ngClass]="{'active': currentRoute === '/students-achievement'}">Achievement</a></li>
            </ul>
          </li>
          <!-- events-->
          <li class="nav-item">
            <a class="nav-link" routerLink="/events" routerLinkActive="active">Events</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" routerLink="/contact" routerLinkActive="active">Contact</a>
          </li>
          <!-- Humb Mega Menu (same logic) -->
          <li class="nav-item dropdown dropdown-mega position-static"
            [ngClass]="{'show': openDropdown === 'humb', 'active': isActiveRoute('/exam-grievance') || isActiveRoute('/blog') || isActiveRoute('/about-iqac') || isActiveRoute('/objectives') || isActiveRoute('/functions') || isActiveRoute('/iqac-members') || isActiveRoute('/aqar') || isActiveRoute('/twentythree-twentyfour') || isActiveRoute('/twentytwo-twentythree') || isActiveRoute('/aqar-tweety') || isActiveRoute('/ict-tools') || isActiveRoute('/minutes-of-meeting')}">

            <a class="nav-link dropdown-toggle" href="javascript:void(0);" (click)="toggleDropdown('humb', $event)"
              (mouseenter)="onMouseEnter('humb')" (mouseleave)="onMouseLeave()">
              <span class="fa fa-bars"></span>
            </a>

            <div class="dropdown-menu dropdown-menu-end" [ngClass]="{'show': openDropdown === 'humb'}"
              (mouseenter)="onMouseEnter('humb')" (mouseleave)="onMouseLeave()">

              <div class="mega-content">
                <div class="container-fluid">
                  <div class="row row-cols-1 row-cols-lg-2">

                    <!-- Left Column -->
                    <div class="col col-md-7">
                      <ul>
                        <h6 class="primary-purple list-count">IQAC</h6>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLink="/about-iqac"
                            [ngClass]="{'active': currentRoute === '/about-iqac'}">About IQAC</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLink="/objectives"
                            [ngClass]="{'active': currentRoute === '/objectives'}">Objectives</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLink="/functions"
                            [ngClass]="{'active': currentRoute === '/functions'}">Functions</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLink="/iqac-members"
                            [ngClass]="{'active': currentRoute === '/iqac-members'}">IQAC Members</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLink="/aqar"
                            [ngClass]="{'active': currentRoute === '/aqar'}">AQAR</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()"
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/aqar/organizational-structure.pdf"
                            target="_blank">Organizational Structure</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLink="/twentythree-twentyfour"
                            [ngClass]="{'active': currentRoute === '/twentythree-twentyfour'}">AQAR 2023-24</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLink="/twentytwo-twentythree"
                            [ngClass]="{'active': currentRoute === '/twentytwo-twentythree'}">AQAR 2022-23</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLink="/aqar-tweety"
                            [ngClass]="{'active': currentRoute === '/aqar-tweety'}">AQAR 2021-22</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLink="/ict-tools"
                            [ngClass]="{'active': currentRoute === '/ict-tools'}">ICT Tools</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLink="/minutes-of-meeting"
                            [ngClass]="{'active': currentRoute === '/minutes-of-meeting'}">MOM</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()" href="javascript:void(0);">ATR</a></li>
                      </ul>
                    </div>
                    <!-- Right Column -->
                    <div class="col col-md-5">
                      <ul>
                        <li><a class="dropdown-item fw-bold" (click)="closeNavbar()"
                            href="https://currentopenings.raisoni.net/" target="_blank">Current Opening</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()"
                            href="https://raisoni.net/raisoni-privilege" target="_blank">Raisoni Privilege</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLink="/exam-grievance"
                            [ngClass]="{'active': currentRoute === '/exam-grievance'}">Exam Grievance</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()" routerLink="/blog"
                            [ngClass]="{'active': currentRoute === '/blog'}">Blogs</a></li>
                        <li><a class="dropdown-item" (click)="closeNavbar()"
                            href="https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcacs/pdf/119-R%26D-ncentives-Policy-ASSN-1.pdf"
                            target="_blank">R & D incentive policy</a></li>
                      </ul>
                    </div>



                  </div>
                </div>
              </div>
            </div>
          </li>

        </ul>
      </div>
    </div>
  </nav>

</header>
